import script from "./Reports.vue?vue&type=script&setup=true&lang=js"
export * from "./Reports.vue?vue&type=script&setup=true&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=f260e164&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f260e164"]])

export default __exports__